/**
 * Update the url path natively. Avoids a react route component unmount/remount when route params change.
 * Use carefully.
 */
export const replaceURLPath = (path: string) => {
  window.history.replaceState(null, '', path);
};
